import "@mantine/form";
import { zodResolver } from "mantine-form-zod-resolver";

//#region src/hooks/form/make-use-form-hook.ts
const makeUseFormHook = (useFormBase) => {
	return ({ schema, ...restProps }) => {
		const useFormProps = { ...restProps };
		if (schema) useFormProps.validate = zodResolver(schema);
		return useFormBase(useFormProps);
	};
};

//#endregion
export { makeUseFormHook };